import { render, staticRenderFns } from "./DesignTokens.vue?vue&type=template&id=38e3f5b8&scoped=true&"
import script from "./DesignTokens.vue?vue&type=script&lang=js&"
export * from "./DesignTokens.vue?vue&type=script&lang=js&"
import style0 from "./DesignTokens.vue?vue&type=style&index=0&id=38e3f5b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e3f5b8",
  null
  
)

export default component.exports